import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';

function BreadValidacaoCD() {
  return (
    <Breadcrumbs
      separator="›"
      aria-label="breadcrumb"
      style={{ marginBottom: '10px', marginTop: '12px' }}
    >
      <Link to="/app" color="textPrimary">
        Inicio
      </Link>
      <Typography color="textPrimary">Validação Chefe de Departamento</Typography>
    </Breadcrumbs>
  );
}
export default BreadValidacaoCD;
